import StatsIcon from "assets/img/icons/sidebarIcons/fiatToCrypto.svg";
import StakingIcon from "assets/img/icons/sidebarIcons/stacking.svg";
import WhaleboardIcon from "assets/img/icons/sidebarIcons/whaleboard.svg";
import { WelcomeBanner } from "./dashboard-text-config";

export interface CardInfo {
  title: string;
  icon: string;
  description: string;
}

export const welcomeBannerOnboarding: WelcomeBanner = {
  title: "Start Building Your Karma",
  description:
    "This is a dedicated AlphaMind Quests page where you can complete various tasks, grow your Karma to access Alpha projects and unlock premium allocations, exclusive perks, ecosystem rewards & more! ",
};

export const cardInfo: CardInfo[] = [
  {
    title: "Exclusive Allocations",
    icon: StakingIcon,
    description:
      "Gain priority access to web3 Alpha projects through premium TGE events & allocations, reserved for high-Karma earners.",
  },
  {
    title: "Community Rewards",
    icon: WhaleboardIcon,
    description:
      "Earn special rewards, NFTs, and recognition within the AlphaMind community for your contributions and engagement.",
  },
  {
    title: "Early Project Insights",
    icon: StatsIcon,
    description:
      "Get early insights into new projects and exclusive updates, giving you an edge in the fast-paced crypto world.",
  },
];

export const onboardingTexts = {
  errorTitle:
    "Oops! Looks like our crypto gremlins are at it again. 🛠️ Try refreshing the page; we'll get you back on track quickly! If it doesn't, please drop us a message in our Discord community!",
  karmaSectionTitle: "Start building your Karma right away & access our Alpha!",
  karmaInfoTitle: "Karma Score: How It Works",
  karmaInfoDescription:
    "Karma is our unique point system that rewards your activities within the AlphaMind ecosystem. Here's how you can build and benefit from your Karma score:",
  karmaList: [
    {
      title: "Earn Karma",
      description:
        "Participate in quests, stake $MIND tokens, and engage with the community.",
    },
    {
      title: "Increase Your Score",
      description:
        "The more you contribute, the higher is your Karma. Activities like token staking, DAO participation, and content creation boost your score.",
    },
    {
      title: "Unlock Rewards",
      description:
        "Higher Karma scores grant you access to higher AlphaMind Tiers with exclusive token allocations, airdrops, ecosystem rewards, and early project insights.",
    },
  ],
  karmaSecondDescription:
    "Start building your Karma today and unlock a world of exclusive opportunities!",
};

export const onboardBanner =
  "https://media.alphamind.co/backgrounds/super-meme/SuperMeme_banner_main.png";
